import { render, staticRenderFns } from "./chooseSingleResource.vue?vue&type=template&id=79d3b65c&scoped=true"
import script from "./chooseSingleResource.vue?vue&type=script&lang=js"
export * from "./chooseSingleResource.vue?vue&type=script&lang=js"
import style0 from "./chooseSingleResource.vue?vue&type=style&index=0&id=79d3b65c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d3b65c",
  null
  
)

export default component.exports